import {
    Button,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Modal,
    TextField,
    Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { getCookie } from "../../utils/cookieHandle";
import { ProgressContext } from "../Context/progressContext";
import { RequestNextApi } from "../../api/Request";
import { ShowNotification } from "../../utils/notification/snackbarUtils";
import { useRouter } from "next/router";

const initialFormData = {
    prefix: "",
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    fullName: "",
    nickName: "",
    firmName: "",
    email: "",
    partnerLevel: null,
    organization: false,
    subscribeMonthlyNewsletter: false,
    subscribeStudyGroup: false,
    subscribeNewProducts: false,
    subscribePartner: false,
    allowAdministrativeEmails: false,
    unsubscribeAllEmail: false,
    subscribeConference: false,
};
function CreateNewAccountButton() {
    const [open, setOpen] = React.useState(false);
    const { update: updateProgress } = useContext(ProgressContext);

    const [formData, setFormData] = React.useState(initialFormData);
    const router = useRouter();

    const onCreateAccount = async () => {
        try {
            if (!formData.firmName?.trim?.()?.length) {
                if (
                    !formData.firstName?.trim?.()?.length ||
                    !formData.lastName?.trim?.()?.length
                ) {
                    ShowNotification.error("First Name and Last Name are required!");
                    return;
                }
            }
            if (!formData.email?.trim?.()?.length) {
                ShowNotification.error("Email is required!");
                return;
            }
            updateProgress({ isLoading: true });
            const result = await RequestNextApi.post("/user/staff-user-create", {
                jwtToken: getCookie("jwt-token"),
                prefix: formData.prefix || "",
                email: formData.email,
                firstName: formData.firstName,
                middleName: formData.middleName,
                lastName: formData.lastName,
                partnerLevel: formData.partnerLevel || 0,
                suffix: formData.suffix,
                nickName: formData.nickName,
                firmName: formData.firmName,
                fullName: formData.fullName,
                isOrganization: formData.organization ? 1 : 0,
                grp_noenewsletter: formData.subscribeMonthlyNewsletter ? 0 : 1, //0 for subscribe 1 for unsubscribe
                grp_nosgemail: formData.subscribeStudyGroup ? 0 : 1, //0 for subscribe 1 for unsubscribe
                grp_noemail: formData.subscribeNewProducts ? 0 : 1, //0 for subscribe 1 for unsubscribe
                grp_noerenew: formData.allowAdministrativeEmails ? 0 : 1, //0 for subscribe 1 for unsubscribe
                grp_noepartner: formData.subscribePartner ? 0 : 1, //0 for subscribe 1 for unsubscribe
                grp_globalunsubscribe: formData.unsubscribeAllEmail ? 1 : 0, //0 for subscribe 1 for unsubscribe
                grp_noeconference: formData.subscribeConference ? 0 : 1, //0 for subscribe 1 for unsubscribe
            });
            if (result.data.success) {
                if (result?.data?.user?.error) {
                    ShowNotification.error(result.data.user?.message || "Failed to create account!");
                    return;
                }
                ShowNotification.success(result.data.message);
                setFormData(initialFormData);
                router.push("/staff/user/" + result.data.user.cfpn_id);
            } else {
                ShowNotification.error(result.data.message);
            }
        } catch (error) {
            ShowNotification.error("Failed to create account!");
        } finally {
            updateProgress({ isLoading: false });
        }
    };
    return (
        <div>
            <Button
                variant="contained"
                className="bg-secondary-500 hover:bg-secondary-500"
                onClick={() => {
                    setOpen(true);
                }}
            >
                Create a new account
            </Button>
            <Modal
                open={open}
                onClose={() => {
                    setOpen(false);
                    setFormData(initialFormData);
                }}
            >
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        onCreateAccount();
                    }}
                >
                    <div className="bg-white max-w-[800px] mx-auto my-10 max-h-[90vh] overflow-auto">
                        <div className="mx-10">
                            <Typography variant="h3" className="text-left py-5">
                                Create a new account
                            </Typography>
                        </div>
                        <div className="mx-10 mt-2">
                            <TextField
                                label="Prefix"
                                select
                                className="w-[33%]"
                                value={formData.prefix || ""}
                                onChange={(e) => {
                                    const newPrefix = e.target.value === "" ? "" : e.target.value;
                                    const nameParts = [
                                        formData.firstName?.trim(),
                                        formData.middleName?.trim(),
                                        formData.lastName?.trim(),
                                        formData.suffix?.trim()
                                    ].filter(part => part && part.length > 0);
                                    setFormData({ 
                                        ...formData, 
                                        prefix: newPrefix,
                                        fullName: nameParts.join(' ')
                                    });
                                }}
                                displayEmpty
                            >
                                <MenuItem value="">No Prefix</MenuItem>
                                <MenuItem value="Mr.">Mr.</MenuItem>
                                <MenuItem value="Mrs.">Mrs.</MenuItem>
                                <MenuItem value="Ms.">Ms.</MenuItem>
                            </TextField>
                        </div>
                        <div className="mx-10 flex justify-between space-x-2 mt-6">
                            <TextField
                                label="First Name"
                                fullWidth
                                value={formData.firstName}
                                onChange={(e) => {
                                    const newFirstName = e.target.value;
                                    const nameParts = [
                                        newFirstName?.trim(),
                                        formData.middleName?.trim(),
                                        formData.lastName?.trim(),
                                        formData.suffix?.trim()
                                    ].filter(part => part && part.length > 0);
                                    setFormData({ 
                                        ...formData, 
                                        firstName: newFirstName,
                                        fullName: nameParts.join(' ')
                                    });
                                }}
                            />
                            <TextField
                                label="Middle Name"
                                fullWidth
                                value={formData.middleName}
                                onChange={(e) => {
                                    const newMiddleName = e.target.value;
                                    const nameParts = [
                                        formData.firstName?.trim(),
                                        newMiddleName?.trim(),
                                        formData.lastName?.trim(),
                                        formData.suffix?.trim()
                                    ].filter(part => part && part.length > 0);
                                    setFormData({ 
                                        ...formData, 
                                        middleName: newMiddleName,
                                        fullName: nameParts.join(' ')
                                    });
                                }}
                            />
                            <TextField
                                label="Last Name"
                                fullWidth
                                value={formData.lastName}
                                onChange={(e) => {
                                    const newLastName = e.target.value;
                                    const nameParts = [
                                        formData.firstName?.trim(),
                                        formData.middleName?.trim(),
                                        newLastName?.trim(),
                                        formData.suffix?.trim()
                                    ].filter(part => part && part.length > 0);
                                    setFormData({ 
                                        ...formData, 
                                        lastName: newLastName,
                                        fullName: nameParts.join(' ')
                                    });
                                }}
                            />
                        </div>
                        <div className="mx-10 flex justify-between space-x-2 mt-6">
                            <TextField
                                label="Suffix"
                                className="w-[33%]"
                                value={formData.suffix}
                                onChange={(e) => {
                                    const newSuffix = e.target.value;
                                    const nameParts = [
                                        formData.firstName?.trim(),
                                        formData.middleName?.trim(),
                                        formData.lastName?.trim(),
                                        newSuffix?.trim()
                                    ].filter(part => part && part.length > 0);
                                    setFormData({ 
                                        ...formData, 
                                        suffix: newSuffix,
                                        fullName: nameParts.join(' ')
                                    });
                                }}
                            />
                            <TextField
                                label="Full Name"
                                className="w-[66%]"
                                value={
                                    formData.fullName
                                }
                                contentEditable={false}
                            />
                        </div>
                        <div className="mx-10 flex justify-between space-x-2 mt-6">
                            <TextField
                                label="Nick Name"
                                fullWidth
                                value={formData.nickName}
                                onChange={(e) =>
                                    setFormData({ ...formData, nickName: e.target.value })
                                }
                            />
                            <TextField
                                label="Firm Name"
                                fullWidth
                                value={formData.firmName}
                                onChange={(e) =>
                                    setFormData({ ...formData, firmName: e.target.value })
                                }
                            />
                        </div>
                        <div className="mx-10 mt-6 flex space-x-2">
                            <TextField
                                label="Email"
                                fullWidth
                                type="email"
                                value={formData.email}
                                required
                                onChange={(e) =>
                                    setFormData({ ...formData, email: e.target.value })
                                }
                            />
                            <TextField
                                label="Partner Level"
                                select
                                fullWidth
                                value={formData.partnerLevel}
                                onChange={(e) =>
                                    setFormData({ ...formData, partnerLevel: e.target.value })
                                }
                            >
                                <MenuItem value={1}>Title Partner</MenuItem>
                                <MenuItem value={2}>Platinum Partner</MenuItem>
                                <MenuItem value={3}>Gold Partner</MenuItem>
                                <MenuItem value={4}>Silver Partner</MenuItem>
                                <MenuItem value={5}>Bronze Partner</MenuItem>
                                <MenuItem value={8}>Inactive Partner</MenuItem>
                                <MenuItem value={9}>Partner Setup</MenuItem>
                                <MenuItem value={null}>None</MenuItem>
                            </TextField>
                            <FormControlLabel
                                control={<Checkbox name="checkedB" color="primary" />}
                                checked={formData.organization}
                                onChange={(e) =>
                                    setFormData({ ...formData, organization: e.target.checked })
                                }
                                label="Organization"
                            />
                        </div>
                        <div className="mx-10 mt-6">
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="subscribeMonthlyNewsletter"
                                            color="primary"
                                        />
                                    }
                                    checked={formData.subscribeMonthlyNewsletter}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            subscribeMonthlyNewsletter: e.target.checked,
                                        })
                                    }
                                    label="Subscribe to Monthly Newsletter"
                                />
                            </div>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="subscribeStudyGroup" color="primary" />
                                    }
                                    checked={formData.subscribeStudyGroup}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            subscribeStudyGroup: e.target.checked,
                                        })
                                    }
                                    label="Subscribe to Communications from my Study Group"
                                />
                            </div>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="subscribeNewProducts" color="primary" />
                                    }
                                    checked={formData.subscribeNewProducts}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            subscribeNewProducts: e.target.checked,
                                        })
                                    }
                                    label="Subscribe to Information on New Products, Tools or Events"
                                />
                            </div>
                            <div>
                                <FormControlLabel
                                    control={<Checkbox name="subscribePartner" color="primary" />}
                                    checked={formData.subscribePartner}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            subscribePartner: e.target.checked,
                                        })
                                    }
                                    label="Subscribe to Information and Resource Offerings from Partners of Kingdom Advisors"
                                />
                            </div>
                            <div>
                                <FormControlLabel
                                    control={<Checkbox name="subscribeConference" color="primary" />}
                                    checked={formData.subscribeConference}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            subscribeConference: e.target.checked,
                                        })
                                    }
                                    label="Subscribe to Information about the Annual Kingdom Advisors Conference"
                                />
                            </div>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="allowAdministrativeEmails"
                                            color="primary"
                                        />
                                    }
                                    checked={formData.allowAdministrativeEmails}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            allowAdministrativeEmails: e.target.checked,
                                        })
                                    }
                                    label="Allow Administrative Emails"
                                />
                            </div>
                            <div>
                                <FormControlLabel
                                    control={
                                        <Checkbox name="unsubscribeAllEmail" color="primary" />
                                    }
                                    checked={formData.unsubscribeAllEmail}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            unsubscribeAllEmail: e.target.checked,
                                        })
                                    }
                                    label="Unsubscribe from ALL email"
                                />
                            </div>
                        </div>
                        <div className="mx-10 mt-6 flex justify-end space-x-2 mb-5">
                            <Button
                                type="button"
                                variant="outlined"
                                className=""
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpen(false);
                                    setFormData(initialFormData);
                                }}
                            >
                                Close
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                className="bg-secondary-500 hover:bg-secondary-500"
                            >
                                Create
                            </Button>
                        </div>
                    </div>
                </form>
            </Modal>
        </div>
    );
}

export default CreateNewAccountButton;
